import React, {Component} from 'react';
import {Cell, Legend, Pie, PieChart, Tooltip} from 'recharts';
import ToolTipPieChart from "./ToolTipPieChart";

class ZSKPieChart extends Component {

    constructor(props) {

        super(props);

        // this.api = new Api();

        // this.state = {activeIndex: null};

        this.handleClick = this.handleClick.bind(this);

    }

    handleClick(data, index) {

        if (!data) return;

        if (this.props.handleClick) {
            // Gather data for
            this.props.handleClick(data, index, this.props.data);
        }

    }

    render() {

        const width = this.props.width ? this.props.width : 500;
        const height = this.props.height ? this.props.height : 500;
        const radOuter = Math.max(Math.round(width / 2.2), 50);
        const radInner = Math.round(radOuter / 2);
        const data = this.props.data;

        return (
            <PieChart key={"PieChart"} width={width} height={height}>
                <Pie key={"Pie"}
                    dataKey={'value'}
                    data={data}
                    outerRadius={radOuter}
                    innerRadius={radInner}
                    fill={'#ccc'}>

                    {data.map((entry, index) => <Cell key={'cell-'+index} fill={entry.color}/>)}
                </Pie>

                <Tooltip active={true} key={"PieTooltip"} content={<ToolTipPieChart translate={this.props.translate} />}/>
            </PieChart>

            // <PieChart onClick={this.handleClick}
            //           width={width}
            //           height={height}
            //           data={this.props.data}
            // >
            //     <XAxis dataKey="name"/>
            //     <YAxis yAxisId="left" orientation="left" stroke={color1}/>
            //     <YAxis yAxisId="right" orientation="right" stroke={color2} padding={{top: height / 2}}/>
            //     <CartesianGrid strokeDasharray="3 3"/>
            //
            //     {/*<Tooltip*/}
            //         {/*content={<ToolTipStitches/>}*/}
            //     {/*/>*/}
            //     <Legend
            //         verticalAlign="top"
            //         payload={[
            //             {value: label1, color: color1},
            //             {value: label2, color: color2}
            //         ]}
            //     />
            //     <Bar yAxisId="left" dataKey="st" name={label1} fill={color1}></Bar>
            //     <Bar yAxisId="right" dataKey="tb" name={label2} fill={color2}></Bar>
            // </PieChart>
        );

    }

}

export default ZSKPieChart;

class TooltipPie extends Component {

    // constructor(props) {
    //     super(props);

    // this.api = new Api();
    // this.state = {activeIndex: null};

    // this.handleClick = this.handleClick.bind(this);
    // }


    render() {

        const {active} = this.props;

        if (!active) return null;

        return null;
/*
        // console.debug("renderTooltip", this.props);

        const {payload, label} = this.props;

        let stitches = parseInt(payload[0].value, 10);
        let tbs = parseInt(payload[1].value, 10);

        if (stitches === 0 && tbs === 0)
            return null; // Don't display tooltip if no data available

        let txtStitches = stitches.toLocaleString();

        let stitchColor = payload[0].color;
        let txtTbs = tbs > 0 ?
            <div style={{color: payload[1].color}}>Threadbreaks: {tbs.toLocaleString()}</div> : '';

        let tbsPerStitches = null;
        if (stitches > 0 && tbs > 0) {
            let val = Math.round(tbs * 1000000 / stitches);
            val /= 100;
            val = val.toLocaleString(undefined, {minimumFractionDigits: 2});
            tbsPerStitches = <div style={{color: payload[1].color}}>Threadbreaks @ 10000 Stitches: {val}</div>
        }

        return (
            <div className="custom-tooltip" style={{backgroundColor: "white", padding: "2px"}}>
                <p>{(label)}</p>

                <div style={{color: stitchColor}}>Stitches: {(txtStitches)}</div>
                {txtTbs}
                {tbsPerStitches}
            </div>
        );
*/
    }

}